import script from "./fieldCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./fieldCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./fieldCheckbox.vue?vue&type=style&index=0&id=dc55b238&lang=scss&scoped=true"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc55b238"]])

export default __exports__